<template>
  <div>
    <header class="header">
      <div class="header-box" v-if="isAdmin">
        <b-navbar toggleable="lg" type="dark" class="navMain isAdmin">
          <b-navbar-toggle target="nav-collapse" class="menu-btn">
            <div class="menu-btn__burger"></div>
          </b-navbar-toggle>
          <b-navbar-brand href="#">
            <img src="@/assets/images/logo-softnext.svg" alt class="logo" />
          </b-navbar-brand>
          <b-collapse id="nav-collapse" class="justify-content-end" is-nav>
            <b-navbar-nav class="justify-content-end">
              <b-nav-item :to="{name: 'admin_dashboard'}" :class="{active: activeDashBoard}">
                <i class="icon-i-panel"></i>
                <span class="nav-text">ダッシュボード</span>
              </b-nav-item>
              <b-nav-item :to="{name: 'admin_companies'}" :class="{active: activeCompany}">
                <i class="icon-i-company"></i>
                <span class="nav-text">業者一覧</span>
              </b-nav-item>
              <b-nav-item
                :to="{name: 'admin_request'}"
                :class="{active: activeRequest}"
                class="nav-link-relative"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11.937"
                  height="15.671"
                  viewBox="0 0 11.937 15.671"
                >
                  <path
                    id="Path_23795"
                    data-name="Path 23795"
                    d="M62.377,15.671h9.182a1.379,1.379,0,0,0,1.377-1.377v-9.7H69.723a1.379,1.379,0,0,1-1.377-1.377V0H62.377A1.379,1.379,0,0,0,61,1.377V14.294A1.379,1.379,0,0,0,62.377,15.671Zm2.755-8.295h4.591a.459.459,0,0,1,0,.918H65.132a.459.459,0,0,1,0-.918Zm0,1.836h4.591a.459.459,0,0,1,0,.918H65.132a.459.459,0,0,1,0-.918Zm0,1.836h4.591a.459.459,0,0,1,0,.918H65.132a.459.459,0,0,1,0-.918ZM63.3,7.376a.459.459,0,1,1-.459.459A.459.459,0,0,1,63.3,7.376Zm0,1.836a.459.459,0,1,1-.459.459A.459.459,0,0,1,63.3,9.213Zm0,1.836a.459.459,0,1,1-.459.459A.459.459,0,0,1,63.3,11.049Z"
                    transform="translate(-61)"
                    fill="#fff"
                  />
                </svg>
                <span class="nav-text">お問い合わせ</span>
                <span v-if="user.total_requests > 0" class="number-total">{{user.total_requests}}</span>
              </b-nav-item>
              <b-nav-item :to="{name: 'admin_me'}" :class="{active: activeMyPage}">
                <i class="icon-i-user"></i>
                <span class="nav-text">マイページ</span>
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
          <div class="userAvt">
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content class="avtLink">
                <img :src="user.avatar" alt class="avt-login" />
              </template>
              <b-dropdown-item @click="logout">
                <i class="icon-i-exit"></i>
                <span class="nav-text">ログアウト</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </b-navbar>
      </div>
      <div class="header-box" v-if="isManager">
        <b-navbar toggleable="lg" type="dark" class="navMain isManager">
          <b-navbar-toggle target="nav-collapse" class="menu-btn">
            <div class="menu-btn__burger"></div>
          </b-navbar-toggle>
          <b-navbar-brand href="#" :to="{name: 'manager_dashboard'}">
            <span class="logo d-none d-lg-block">{{truncate(companyName,15,'...')}}</span>
            <span class="logo d-block d-lg-none">{{truncate(companyName,8,'...')}}</span>
          </b-navbar-brand>
          <b-collapse id="nav-collapse" class="justify-content-end" is-nav>
            <b-navbar-nav class="justify-content-end">
              <b-nav-item :to="{name: 'manager_dashboard'}" :class="{active: activeDashBoard}">
                <i class="icon-i-panel"></i>
                <span class="nav-text">ダッシュボード</span>
              </b-nav-item>
              <b-nav-item :class="{active: activeFile}" @click="showFile">
                <i class="icon-i-coppy"></i>
                <span class="nav-text">ファイル一覧</span>
              </b-nav-item>
              <b-nav-item :class="{active: activeIsListEmployee}" :to="{name: 'manager_employee'}">
                <i class="icon-i-contact"></i>
                <span class="nav-text">社員一覧</span>
              </b-nav-item>
              <b-nav-item :class="{active: activeIsVendor}" :to="{name: 'manager_company'}">
                <i class="icon-i-company"></i>
                <span class="nav-text">会社概要</span>
              </b-nav-item>
              <b-nav-item :class="{active: activeMyPage}" :to="{name: 'manager_me'}">
                <i class="icon-i-user"></i>
                <span class="nav-text">マイページ</span>
              </b-nav-item>
            </b-navbar-nav>
            <!-- Right aligned nav items -->
          </b-collapse>
          <div class="userAvt">
            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content class="avtLink">
                <img :src="user.avatar" alt class="avt-login" />
              </template>
              <b-dropdown-item @click="logout">
                <i class="icon-i-exit"></i>
                <span class="nav-text">ログアウト</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </b-navbar>
      </div>
      <div class="header-box header-box-employee" v-if="isEmployee">
        <b-navbar toggleable="lg" type="dark" class="navMain isEmployee">
          <b-navbar-toggle target="nav-collapse" class="menu-btn">
            <div class="menu-btn__burger"></div>
          </b-navbar-toggle>
          <b-navbar-brand :to="{name: 'employee_dashboard'}">
            <span class="logo d-none d-lg-block">{{truncate(companyName,15,'...')}}</span>
            <span class="logo d-block d-lg-none">{{truncate(companyName,8,'...')}}</span>
          </b-navbar-brand>
          <b-collapse id="nav-collapse" class="justify-content-end" is-nav>
            <b-navbar-nav class="justify-content-end menu-employee">
              <b-nav-item :to="{name: 'employee_dashboard'}" :class="{active: activeDashBoard}">
                <i class="icon-i-panel"></i>
                <span class="nav-text">ダッシュボード</span>
              </b-nav-item>
              <b-nav-item @click="showFileEmployee" :class="{active: activeEmployeeFile }">
                <i class="icon-i-coppy"></i>
                <span class="nav-text">ファイル一覧</span>
              </b-nav-item>
              <b-nav-item :to="{name: 'employee_company'}" :class="{active: activeEmployeeVendor}">
                <i class="icon-i-company"></i>
                <span class="nav-text">会社概要</span>
              </b-nav-item>
              <b-nav-item :to="{name: 'employee_me'}" :class="{active: activeMyPage }">
                <i class="icon-i-user"></i>
                <span class="nav-text">マイページ</span>
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
          <div class="header__notifyIcon nav-link-relative" v-on-clickaway="away" v-if="isEmployee">
            <div class="parent-div-noti">
              <div v-on:click="showDataNotification" class="btn-notify">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.044"
                  height="24.053"
                  viewBox="0 0 20.044 24.053"
                >
                  <g id="Group_11525" data-name="Group 11525" transform="translate(-1198)">
                    <g id="Group_11524" data-name="Group 11524" transform="translate(1155.325)">
                      <g id="Group_10427" data-name="Group 10427" transform="translate(42.675)">
                        <g id="Group_10426" data-name="Group 10426">
                          <path
                            id="Path_23091"
                            data-name="Path 23091"
                            d="M62.648,19.655l-1.721-2.779a8.061,8.061,0,0,1-1.215-4.247V10.195A6.838,6.838,0,0,0,54.7,3.685V1.942a2.005,2.005,0,0,0-4.009,0V3.685a6.838,6.838,0,0,0-5.011,6.51v2.434a8.066,8.066,0,0,1-1.214,4.246l-1.721,2.779a.472.472,0,0,0-.006.489.5.5,0,0,0,.435.247H62.218a.505.505,0,0,0,.436-.246A.474.474,0,0,0,62.648,19.655Z"
                            transform="translate(-42.675)"
                            fill="#748175"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_10429"
                        data-name="Group 10429"
                        transform="translate(48.851 21.611)"
                      >
                        <g id="Group_10428" data-name="Group 10428">
                          <path
                            id="Path_23092"
                            data-name="Path 23092"
                            d="M188.815,469.333a4.248,4.248,0,0,0,7.691,0Z"
                            transform="translate(-188.815 -469.333)"
                            fill="#748175"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span
                  class="number-total number-total-custom"
                  v-if="notificationAmount > 0"
                >{{checkAmountNotification(notificationAmount)}}</span>
              </div>
              <div>
                <div class="notifi-div" v-show="activeNotification">
                  <div class="notify-title">
                    <strong>通知</strong>
                  </div>
                  <ul
                    class="header__liNotify scroll-bar"
                    v-on:scroll="scrollDataNotification"
                    id="data-notification"
                  >
                    <li v-show="dataNotifications.length === 0" class="no-notify">通知がありません。</li>
                    <li
                      v-for="(notification,index) in dataNotifications"
                      :key="index"
                      class="notify-item"
                      v-on:click="showDetailNotification (notification.activity_log_id,notification.file_id,notification.notification_status,notification.file_deleted_at)"
                      v-bind:class="notification.notification_status === 0 ? 'notification_not_read' : '' "
                    >
                      <p v-if="dataNotifications.length === 0" class="no-notify">利用できない通知</p>
                      <div class="d-flex header__liNotify__child">
                        <img :src="notification.avatar" alt class="header__avatarNoti" />
                        <div class="header__notify w-100">
                          <div class="d-flex justify-content-between align-items-center">
                            <span class="header__liNotify__name">{{truncate(notification.user_name,15,'...')}}</span>
                            <span
                              class="header__liNotify__datetime"
                            >{{calculateTimeAgoNotification (notification.created_at)}}</span>
                          </div>
                          <div
                            class="header__notify__content line-2"
                          >{{getContentNotification(notification)}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="header__notifyIcon nav-link-relative" v-on-clickaway="away" v-if="isAdmin">
            <div class="parent-div-noti">
              <div v-on:click="showDataNotification" class="btn-notify">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.044"
                  height="24.053"
                  viewBox="0 0 20.044 24.053"
                >
                  <g id="Group_11525" data-name="Group 11525" transform="translate(-1198)">
                    <g id="Group_11524" data-name="Group 11524" transform="translate(1155.325)">
                      <g id="Group_10427" data-name="Group 10427" transform="translate(42.675)">
                        <g id="Group_10426" data-name="Group 10426">
                          <path
                            id="Path_23091"
                            data-name="Path 23091"
                            d="M62.648,19.655l-1.721-2.779a8.061,8.061,0,0,1-1.215-4.247V10.195A6.838,6.838,0,0,0,54.7,3.685V1.942a2.005,2.005,0,0,0-4.009,0V3.685a6.838,6.838,0,0,0-5.011,6.51v2.434a8.066,8.066,0,0,1-1.214,4.246l-1.721,2.779a.472.472,0,0,0-.006.489.5.5,0,0,0,.435.247H62.218a.505.505,0,0,0,.436-.246A.474.474,0,0,0,62.648,19.655Z"
                            transform="translate(-42.675)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_10429"
                        data-name="Group 10429"
                        transform="translate(48.851 21.611)"
                      >
                        <g id="Group_10428" data-name="Group 10428">
                          <path
                            id="Path_23092"
                            data-name="Path 23092"
                            d="M188.815,469.333a4.248,4.248,0,0,0,7.691,0Z"
                            transform="translate(-188.815 -469.333)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span
                  class="number-total number-total-custom"
                  v-if="notificationAmount > 0"
                >{{checkAmountNotification(notificationAmount)}}</span>
              </div>
              <div>
                <div class="notifi-div" v-show="activeNotification">
                  <div class="notify-title">
                    <strong>通知</strong>
                  </div>
                  <ul
                    class="header__liNotify scroll-bar"
                    v-on:scroll="scrollDataNotification"
                    id="data-notification"
                  >
                    <li v-show="dataNotifications.length === 0" class="no-notify">通知がありません。</li>
                    <li
                      v-for="(notification,index) in dataNotifications"
                      :key="index"
                      class="notify-item"
                      v-on:click="showDetailNotification (notification.activity_log_id,notification.file_id,notification.notification_status,notification.file_deleted_at)"
                      v-bind:class="notification.notification_status === 0 ? 'notification_not_read' : '' "
                    >
                      <p v-if="dataNotifications.length === 0" class="no-notify">利用できない通知</p>
                      <div class="d-flex header__liNotify__child">
                        <img :src="notification.avatar" alt class="header__avatarNoti" />
                        <div class="header__notify w-100">
                          <div class="d-flex justify-content-between align-items-center">
                            <span class="header__liNotify__name">{{truncate(notification.user_name,15,'...')}}</span>
                            <span
                              class="header__liNotify__datetime"
                            >{{calculateTimeAgoNotification (notification.created_at)}}</span>
                          </div>
                          <div
                            class="header__notify__content line-2"
                          >{{getContentNotification(notification)}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="header__notifyIcon nav-link-relative" v-on-clickaway="away" v-if="isManager">
            <div class="parent-div-noti">
              <div v-on:click="showDataNotification" class="btn-notify">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.044"
                  height="24.053"
                  viewBox="0 0 20.044 24.053"
                >
                  <g id="Group_11525" data-name="Group 11525" transform="translate(-1198)">
                    <g id="Group_11524" data-name="Group 11524" transform="translate(1155.325)">
                      <g id="Group_10427" data-name="Group 10427" transform="translate(42.675)">
                        <g id="Group_10426" data-name="Group 10426">
                          <path
                            id="Path_23091"
                            data-name="Path 23091"
                            d="M62.648,19.655l-1.721-2.779a8.061,8.061,0,0,1-1.215-4.247V10.195A6.838,6.838,0,0,0,54.7,3.685V1.942a2.005,2.005,0,0,0-4.009,0V3.685a6.838,6.838,0,0,0-5.011,6.51v2.434a8.066,8.066,0,0,1-1.214,4.246l-1.721,2.779a.472.472,0,0,0-.006.489.5.5,0,0,0,.435.247H62.218a.505.505,0,0,0,.436-.246A.474.474,0,0,0,62.648,19.655Z"
                            transform="translate(-42.675)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_10429"
                        data-name="Group 10429"
                        transform="translate(48.851 21.611)"
                      >
                        <g id="Group_10428" data-name="Group 10428">
                          <path
                            id="Path_23092"
                            data-name="Path 23092"
                            d="M188.815,469.333a4.248,4.248,0,0,0,7.691,0Z"
                            transform="translate(-188.815 -469.333)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                <span
                  class="number-total number-total-custom"
                  v-if="notificationAmount > 0"
                >{{checkAmountNotification(notificationAmount)}}</span>
              </div>
              <div>
                <div class="notifi-div" v-show="activeNotification">
                  <div class="notify-title">
                    <strong>通知</strong>
                  </div>
                  <ul
                    class="header__liNotify scroll-bar"
                    v-on:scroll="scrollDataNotification"
                    id="data-notification"
                  >
                    <li v-show="dataNotifications.length === 0" class="no-notify">通知がありません。</li>
                    <li
                      v-for="(notification,index) in dataNotifications"
                      :key="index"
                      class="notify-item"
                      v-on:click="showDetailNotification (notification.activity_log_id,notification.file_id,notification.notification_status,notification.file_deleted_at)"
                      v-bind:class="notification.notification_status === 0 ? 'notification_not_read' : '' "
                    >
                      <p v-if="dataNotifications.length === 0" class="no-notify">利用できない通知</p>
                      <div class="d-flex header__liNotify__child">
                        <img :src="notification.avatar" alt class="header__avatarNoti" />
                        <div class="header__notify w-100">
                          <div class="d-flex justify-content-between align-items-center">
                            <span class="header__liNotify__name">{{truncate(notification.user_name,15,'...')}}</span>
                            <span
                              class="header__liNotify__datetime"
                            >{{calculateTimeAgoNotification (notification.created_at)}}</span>
                          </div>
                          <div
                            class="header__notify__content line-2"
                          >{{getContentNotification(notification)}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="userAvt">
            <b-nav-item-dropdown right>
              <template v-slot:button-content class="avtLink">
                <img :src="user.avatar" alt class="avt-login" />
              </template>
              <b-dropdown-item href="https://www.softnext.co.jp/m2next/contact">
                <img src="@img/icon/icon-question.svg" />
                <span class="nav-text">サポートセンター</span>
              </b-dropdown-item>
              <b-dropdown-item @click="logout" class="no-border">
                <i class="icon-i-exit"></i>
                <span class="nav-text">ログアウト</span>
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
        </b-navbar>
      </div>
    </header>
    <DetailNotification />
    <div class="message-error-notification" v-show="statusFile">
      <div class="popup-mess-error-notification">
        <div class="popup-mess-content">
          <div class="text-center">
            <p>ファイルが存在しません。</p>
            <button v-on:click="errorNotification" class="btn-primary">閉じる</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailNotification from '@/views/Employee/MyPage/DetailNotification.vue'
import { mapState } from 'vuex'
import { VBModal } from 'bootstrap-vue'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import { ACTION } from '../../utils/constant'
import { directive as onClickaway } from 'vue-clickaway'

export default {
  name: 'Header',
  data () {
    return {
      showNotification: 3,
      activeNotification: false,
      getNoti: true,
      statusNotification: true,
      statusFile: false,
      pageNotifications: 1,
      dataNotifications: []
    }
  },
  props: {
    page: ''
  },
  components: {
    DetailNotification
  },
  methods: {
    away () {
      this.activeNotification = false
      this.statusNotification = true
    },
    errorNotification () {
      this.statusFile = false
    },
    logout () {
      this.$store.dispatch('allAuth/logout')
    },
    showFile () {
      this.$router.push('/manager/items/0')
    },
    showFileEmployee () {
      this.$router.push('/employee/items/0')
    },
    calculateTimeAgoNotification (createdAt) {
      moment.locale('ja')
      var myTimezone = momentTimezone.tz.guess()
      var hourTimezone = momentTimezone.tz(myTimezone).format('Z')
      createdAt = moment(createdAt).add(hourTimezone, 'hours').format('YYYY-MM-DD hh:mm:ss')
      return moment(createdAt).startOf('minutes').from(moment().format('YYYY-MM-DD hh:mm:ss'))
    },
    getDataNotification () {
      this.$store.dispatch('employeeDashboard/getNotification', {
        page: this.pageNotifications
      })
    },
    checkAmountNotification (notificationAmount) {
      if (notificationAmount > 99) {
        return '99+'
      }
      return notificationAmount
    },
    getContentNotification (notification) {
      if (notification.action_type === ACTION.ACTION_TYPE_LOG_CREATE) {
        return (
          this.truncate(notification.user_name, 10, '...') +
          'が' +
          this.checkTypeFileNotification(notification.media_type_id) +
          'ファイルをアップロードしました: ' +
          this.truncate(notification.file_name, 10, '...')
        )
      }
      if (notification.action_type === ACTION.ACTION_TYPE_LOG_UPDATE) {
        return (
          this.truncate(notification.user_name, 10, '...') +
          'が' +
          this.checkTypeFileNotification(notification.media_type_id) +
          'ファイルを編集しました: ' +
          this.truncate(notification.file_name, 10, '...')
        )
      }
    },
    checkTypeFileNotification (type) {
      switch (type) {
        case 1:
          return 'folder'
        case 2:
          return 'pdf'
        case 3:
          return '画像'
        case 4:
          return '動画'
      }
    },
    showDetailNotification (notificationId, fileId, status, statusFile) {
      this.activeNotification = false
      if (statusFile) {
        this.statusFile = true
      } else {
        this.statusNotification = false
        var id = fileId
        this.$store.dispatch('employeeFolder/getDetailFile', { id })
        this.$store.dispatch('employeeFolder/activeFile', {
          id: id,
          action_type: ACTION.ACTION_TYPE_LOG_READ
        })
        this.$root.$emit(
          'bv::show::modal',
          'modalDetailNotification',
          '#modalDetailNotification'
        )
      }
      this.pageNotifications = 1
      this.$store.dispatch('employeeDashboard/updateNotification', notificationId)
    },
    showDataNotification () {
      this.activeNotification = !this.activeNotification
    },
    scrollDataNotification () {
      var scrollNotification = document.getElementById('data-notification')
      if (
        Math.round(scrollNotification.scrollTop) + scrollNotification.offsetHeight ===
        scrollNotification.scrollHeight
      ) {
        if (this.notifications.length > 0) {
          this.pageNotifications = this.pageNotifications + 1
          this.getDataNotification()
        }
      }
    }
  },
  computed: {
    ...mapState({
      companyName: (state) => state.allAuth.companyName,
      user: (state) => state.allAuth.user,
      vendor: (state) => state.employeeVendor.vendor,
      notificationAmount: (state) => state.employeeDashboard.notificationAmount,
      notifications: (state) => state.employeeDashboard.notification
    }),
    isAdmin () {
      return this.user.role_name === 'admin'
    },
    isManager () {
      return this.user.role_name === 'manager'
    },
    isEmployee () {
      return this.user.role_name === 'employee'
    },
    activeIsListEmployee () {
      return this.page === 'manager_users'
    },
    activeIsVendor () {
      return this.page === 'manager_vendor'
    },
    activeMyPage () {
      return this.page === 'my_page'
    },
    activeDashBoard () {
      return this.page === 'dashboard'
    },
    activeFile () {
      return this.page === 'manager_file'
    },
    activeCompany () {
      return this.page === 'company'
    },
    activeRequest () {
      return this.page === 'request'
    },
    activeEmployeeFile () {
      return this.page === 'employee_file'
    },
    activeEmployeeVendor () {
      return this.page === 'employee_vendor'
    },
    getDataFirstCall () {
      return this.notifications
    }
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal,
    onClickaway: onClickaway
  },
  mounted () {
    if (this.user.role_name === 'employee') {
      this.getDataNotification()
    }
    this.$store.dispatch('allAuth/getProfile')
  },
  watch: {
    'user.role_name' () {
      if (this.user.role_name === 'employee') {
        this.getDataNotification()
      }
    },
    'notifications' (value) {
      if (value) {
        if (this.pageNotifications === 1) {
          this.dataNotifications = []
        }
        value.forEach(element => {
          this.dataNotifications.push(element)
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/stylesheet/auth/listfile.scss";
@import "@/assets/stylesheet/vendor/detail_vendor.scss";
</style>



// WEBPACK FOOTER //
// src/components/share/Header.vue